import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import AboutUs from "./components/pages/AboutUs";
import Location from "./components/pages/Location";
import StandarService from "./components/pages/StandarService";
import BridalService from "./components/pages/BridalService";
import SpecialtyService from "./components/pages/SpecialtyService";
import CustomService from "./components/pages/CustomService";
import Services from "./components/pages/Services";
import Dashboard from "./components/dashboard/Dashboard";
import Footer from "./components/footer/Footer";
import PolicyPage from "./components/more/PolicyPage";
import ContactUs from "./components/pages/ContactUs";
import { HelmetProvider } from "react-helmet-async";
import "./App.scss";

const App = () => {

  return (
    <HelmetProvider>
    <div className="app-container">
      <Router>
        <Dashboard />
        <div className="router-container">
          <Routes>
            <Route path="/" element={<Navigate to="/services" replace />} />
            <Route
              path="/about-us"
              element={<AboutUs  />}
            />
            <Route
              path="/location"
              element={<Location />}
            />
            <Route
              path="/services"
              element={<Services />}
            />
            <Route
              path="/services/standard"
              element={<StandarService/>}
            />
            <Route
              path="/services/bridal"
              element={<BridalService />}
            />
            <Route
              path="/services/specialty"
              element={<SpecialtyService />}
            />
             <Route
              path="/services/custom"
              element={<CustomService  />}
            />
            <Route
              path="/policy"
              element={<PolicyPage />}
            />
             <Route
              path="/contact-us"
              element={<ContactUs />}
            />
          </Routes>
        </div>
        <Footer  />
      </Router>
    </div>
    </HelmetProvider>
  );
};

export default App;
